module.exports = __webpack_public_path__ + "static/media/Home-page-img2.0ee28128.png";